<template>
  <div>
    <label class="checkbox"> <input type="checkbox" v-model="dismissed" /> Mostra solo i dimessi </label>
  </div>
</template>

<script>
import { Route } from '../../../route';
import { getCookie } from '../../../plugins/userUtils';

export default {
  name: 'dismissedFilter',
  props: ['buId', 'index'],
  data() {
    return {
      dismissed: false,
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  watch: {
    dismissed: function (val) {
      this.$emit('selected', { data_selected: { dismissed: val }, index: this.index });
    },
  },
};
</script>

<style lang="scss" scoped></style>
